var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2459 1.2712C0.94784 1.59992 0.920743 2.11432 1.16461 2.4768L1.2459 2.58065L7.97342 10L1.2459 17.4193C0.94784 17.7481 0.920743 18.2625 1.16461 18.625L1.2459 18.7288C1.54396 19.0575 2.01037 19.0874 2.33904 18.8185L2.43321 18.7288L9.7541 10.6547C10.0522 10.326 10.0793 9.8116 9.83539 9.44912L9.7541 9.34527L2.43321 1.2712C2.10534 0.909601 1.57376 0.909601 1.2459 1.2712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.f6c38c99b9199620d03da557835ca2ea.svg";
export { ForwardRef as ReactComponent };